/**
 * Stone Type chips — two-line option chips over Thinkspace's Stone Type select.
 *
 * Copy:
 *   CZ · Clean & Clear
 *   Moissanite · Exceptional Sparkle
 *   Lab-Grown Diamond · Classic Fire, Modern Value
 *   Natural Diamond · Rare & Timeless
 *
 * Sparkle (`sj-option-chip--sparkle`) always lands on the highest tier
 * currently offered for the selected metal:
 *   Natural → Lab-Grown → Moissanite → CZ
 *
 * Depends on: sj-3d-builder.js, sj-metal-chips.css
 */
(function () {
  'use strict';

  var B = window.Sj3dBuilder;
  if (!B) return;

  var STONE_OPTION = 'Stone Type';
  var READY = 'data-sj-stone-chips-ready';

  var STONE_COPY = {
    CZ: { title: 'CZ', subtitle: 'Clean & Clear' },
    Moissanite: { title: 'Moissanite', subtitle: 'Exceptional Sparkle' },
    'Diamond - Lab Grown': {
      title: 'Lab-Grown Diamond',
      subtitle: 'Classic Fire, Modern Value',
    },
    'Diamond - Earth-Mined': {
      title: 'Natural Diamond',
      subtitle: 'Rare & Timeless',
    },
  };

  function stoneCopy(value, text) {
    var raw = String(value || '').trim();
    var label = String(text || '').trim();
    if (STONE_COPY[raw]) return STONE_COPY[raw];

    var hay = (raw + ' ' + label).toLowerCase();
    if (/\bcz\b|cubic\s*zirconia/.test(hay)) return STONE_COPY.CZ;
    if (/moissanite/.test(hay)) return STONE_COPY.Moissanite;
    if (/lab[\s-]*grown|lab\s*diamond/.test(hay)) {
      return STONE_COPY['Diamond - Lab Grown'];
    }
    if (/earth[\s-]*mined|natural\s*diamond/.test(hay)) {
      return STONE_COPY['Diamond - Earth-Mined'];
    }
    if (/diamond/.test(hay)) return STONE_COPY['Diamond - Lab Grown'];

    return {
      title: raw || label || 'Stone',
      subtitle: label && label !== raw ? label : '',
    };
  }

  /** Higher = more premium. */
  function stoneTier(copy) {
    if (!copy) return 0;
    if (copy.title === 'Natural Diamond') return 4;
    if (copy.title === 'Lab-Grown Diamond') return 3;
    if (copy.title === 'Moissanite') return 2;
    if (copy.title === 'CZ') return 1;
    return 0;
  }

  function highestAvailableTitle(opts) {
    var bestTitle = '';
    var bestTier = 0;
    for (var i = 0; i < opts.length; i++) {
      var copy = stoneCopy(opts[i].value, opts[i].textContent);
      var tier = stoneTier(copy);
      if (tier > bestTier) {
        bestTier = tier;
        bestTitle = copy.title;
      }
    }
    return bestTitle;
  }

  function ensureMount(field) {
    var mount = field.querySelector('[data-sj-stone-chips]');
    if (!mount) {
      mount = document.createElement('div');
      mount.setAttribute('data-sj-stone-chips', '');
      field.appendChild(mount);
    }
    return mount;
  }

  function optionListSignature(items) {
    var parts = [];
    for (var i = 0; i < items.length; i++) {
      parts.push(
        String(items[i].value || '') + ':' + (items[i].disabled ? '1' : '0')
      );
    }
    return parts.join('|');
  }

  function buildChipButton(value, copy, selected, sparkle) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sj-option-chip';
    if (sparkle) btn.classList.add('sj-option-chip--sparkle');
    btn.classList.toggle('is-selected', value === selected);
    btn.setAttribute('aria-pressed', value === selected ? 'true' : 'false');
    btn.setAttribute(
      'aria-label',
      copy.subtitle ? copy.title + ', ' + copy.subtitle : copy.title
    );

    var text = document.createElement('span');
    text.className = 'sj-option-chip__text';

    var title = document.createElement('span');
    title.className = 'sj-option-chip__title';
    title.textContent = copy.title;
    text.appendChild(title);

    if (copy.subtitle) {
      var sub = document.createElement('span');
      sub.className = 'sj-option-chip__subtitle';
      sub.textContent = copy.subtitle;
      text.appendChild(sub);
    }

    btn.appendChild(text);
    return btn;
  }

  function renderStoneChips(field) {
    var select = field.querySelector('select');
    if (!select) return;

    var mount = ensureMount(field);
    var current = String(select.value || '');
    var opts = Array.from(select.options || []).filter(function (opt) {
      return !opt.disabled && String(opt.value || '').trim() !== '';
    });
    if (!opts.length) return;

    var wrap = document.createElement('div');
    wrap.className = 'sj-option-chips sj-stone-chips';
    wrap.setAttribute('data-sj-sig', optionListSignature(opts));
    wrap.setAttribute('role', 'group');
    wrap.setAttribute('aria-label', 'Stone Type');

    var sparkleTitle = highestAvailableTitle(opts);

    opts.forEach(function (opt) {
      var value = String(opt.value).trim();
      var copy = stoneCopy(value, opt.textContent);
      var btn = buildChipButton(
        value,
        copy,
        current,
        Boolean(sparkleTitle && copy.title === sparkleTitle)
      );
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        B.setSelectValue(select, value);
        window.setTimeout(function () {
          refreshStoneChips(field);
        }, 0);
      });
      wrap.appendChild(btn);
    });

    mount.innerHTML = '';
    mount.appendChild(wrap);
    field.classList.add('sj-stone-chips-host');
  }

  function refreshStoneChips(field) {
    var select = field.querySelector('select');
    if (!select) return;
    var opts = Array.from(select.options || []).filter(function (opt) {
      return !opt.disabled && String(opt.value || '').trim() !== '';
    });
    var mount = field.querySelector('[data-sj-stone-chips]');
    var wrap = mount && mount.querySelector('.sj-stone-chips');
    var buttons = wrap && wrap.querySelectorAll('.sj-option-chip');
    var sig = optionListSignature(opts);
    if (
      wrap &&
      buttons &&
      wrap.getAttribute('data-sj-sig') === sig &&
      buttons.length === opts.length
    ) {
      var current = String(select.value || '');
      for (var i = 0; i < buttons.length; i++) {
        var on = String(opts[i].value).trim() === current;
        buttons[i].classList.toggle('is-selected', on);
        buttons[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      }
      return;
    }
    renderStoneChips(field);
  }

  function enhanceStoneField(field) {
    if (!field || field.getAttribute(READY) === '1') return;
    var select = field.querySelector('select');
    if (!select) return;

    field.setAttribute(READY, '1');
    renderStoneChips(field);

    var refresh = B.rafDebounce
      ? B.rafDebounce(function () {
          refreshStoneChips(field);
        })
      : function () {
          refreshStoneChips(field);
        };
    var mo = new MutationObserver(refresh);
    mo.observe(select, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['value', 'selected', 'disabled'],
    });
    select.addEventListener('change', refresh);
    field._sjStoneMo = mo;
  }

  function scan() {
    document
      .querySelectorAll('[data-option="' + STONE_OPTION + '"]')
      .forEach(enhanceStoneField);
  }

  B.bootOnWidget(function (widget) {
    B.watchWidget(widget, scan);
  });
})();
